export const sentryDsn =
  'https://08d6b55b1efa49748d6109e9e4dd8315@o474086.ingest.sentry.io/6722938';
export const sentrySampleRate = 0.2;
export const sentryDenyUrls = [/www\.googletagmanager\.com/i];
